import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { GetCardPinUseCase } from './GetCardPinUseCase'

export const getCardPinUseCase = new GetCardPinUseCase({
  cardRepository,
}).execute
